import FeaturedListingType from '@domain-group/fe-allhomes-library/lib/enums/featured-listing-type';
import LocalityType from '@domain-group/fe-allhomes-library/lib/enums/locality-type';
import { postRequest, lookupFeaturedProperty } from '../utils';
var lookupRegionGroup = (query, props, state) => {
  var _query$getSingleLocal = query.getSingleLocality(),
    id = _query$getSingleLocal.id,
    type = _query$getSingleLocal.type;
  return postRequest(props.endpoints.regionGroupEndpoint, {
    id,
    type
  }).then(regionGroup => ({
    regionGroup
  })).catch(() => ({
    regionGroup: state.regionGroup
  }));
};
var lookupTopSpot = (query, props, state) => lookupFeaturedProperty(query, props, state, FeaturedListingType.TOP_SPOT);
export default (function () {
  var pageType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'new-listings';
  return {
    extraTasks: [lookupRegionGroup, lookupTopSpot],
    breadcrumbRules: {
      additional: [{
        text: pageType === 'new-listings' ? 'New Listings' : 'Browse by New Price'
      }],
      bypassCanberra: false
    },
    singleLocalityTypes: [LocalityType.DIVISION.type, LocalityType.DISTRICT.type, LocalityType.REGION.type]
  };
});